// import { evalStringCodeUnsafe } from './code-stringify'

// export const updateFile = (codeStr, el, s) => {
// const { content, key, code, type, format } = s
// s.getRootState().files[key] = { content, code, key, type, format }
// el.getRootState().update({
//   files: { [key]: s.files[key] }
// }, {
//   message: `Updated ${s.key} function`,
//   preventUpdate: true
// })
// window.requestAnimationFrame(() => {
//   const Canvas = el.getCanvas() || el.__ref.root.data.Canvas
//   const { Iframe } = this.getChosenScene().ComponentFrameCanvas
//   const { contentWindow } = Iframe.node
//   const { chosen, Collection } = Canvas.data.chosen
//   const evalCode = evalStringCodeUnsafe(codeStr, this.getSecrets(), contentWindow)
//   if (chosen || Collection) {
//     const chosenCtx = (chosen || Collection).context
//     chosenCtx.files[s.key].code = evalCode
//   }
//   const { packages } = contentWindow
//   packages.files[s.key] = evalCode
//   packages.functions[s.key] = evalCode
//   packages.utils[s.key] = evalCode
//   Iframe.update()
// })
// }

export async function openFile(key) {
  await this.call('openRouterModal', '/edit-file', { key: key || this.state.key })
}

function appendCopyToFileName(fileName) {
  const dotIndex = fileName.lastIndexOf('.')
  const hasExtension = dotIndex !== -1
  let name = hasExtension ? fileName.substring(0, dotIndex) : fileName
  const extension = hasExtension ? fileName.substring(dotIndex) : ''

  // Regular expression to check if '-copy' followed by an optional number exists
  const copyRegex = /-copy(?:-(?<temp1>\d+))?$/u
  const match = name.match(copyRegex)

  if (match) {
    // If '-copy' exists, increment the number
    const copyNumber = match[1] ? parseInt(match[1], 10) + 1 : 1
    name = name.replace(copyRegex, `-copy-${copyNumber}`)
  } else {
    // Otherwise, just append '-copy'
    name += '-copy'
  }

  return name + extension
}
